import { render, staticRenderFns } from "./ChangeBalanceLimit.vue?vue&type=template&id=6bc76568&scoped=true&"
import script from "./ChangeBalanceLimit.vue?vue&type=script&lang=ts&"
export * from "./ChangeBalanceLimit.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeBalanceLimit.vue?vue&type=style&index=0&id=6bc76568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc76568",
  null
  
)

export default component.exports